import { createAsyncThunk } from '@reduxjs/toolkit'
import { ConfirmationDialogProps } from 'features/ConfirmationDialog/ConfirmationDialog'
import i18n from 'i18next'
import { ShowException } from 'store/Application/appActions'
import { UIActions } from 'store/UI/UIActions'
import { newProjectActions } from '../newProjectReducer'
import { bomItemSelector } from '../selectors/bomItemSelector'
import { projectSelectors } from '../selectors/projectSelectors'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'

export const deleteBoMItem = createAsyncThunk<any, any, { state: any }>(
  'boM/deleteBoMItem',
  async ({ bomItemId }: { bomItemId?: string }, thunkAPI) => {
    const projectAPI = projectAPIBuilder(thunkAPI.getState)
    try {
      if (!bomItemId) {
        const selectedBomItems = projectSelectors.selectedBomItemsSelector(
          thunkAPI.getState()
        )

        if (!selectedBomItems.length) {
          console.error('no bom item to delete')
          return
        }

        thunkAPI.dispatch(
          UIActions.OpenModal('ConfirmationDialog', {
            title: i18n.t('project:delete-parts-count', {
              count: selectedBomItems.length,
            }),
            onConfirm: () => {
              try {
                thunkAPI.dispatch(UIActions.CloseModal())

                selectedBomItems.forEach((bomItem) => {
                  thunkAPI.dispatch(newProjectActions.deleteBomItem(bomItem.id))
                })

                thunkAPI.dispatch(newProjectActions.clearSelectedBomItems())

                return projectAPI.api.DeleteRowOrAssembly(
                  projectAPI.projectId,
                  selectedBomItems.map((x) => x.id)
                )
              } catch (err) {
                ShowException('project', err)
                thunkAPI.dispatch(fetchProject(projectAPI.projectId))
                throw err
              }
            },
            onCancel: () => {
              return Promise.resolve()
            },
          } as ConfirmationDialogProps)
        )

        return
      }

      const bomItem = bomItemSelector(thunkAPI.getState(), bomItemId)

      switch (bomItem?.type) {
        case 'RoutingHeader':
        case 'MaterialHeader':
        case 'Assembly':
          if (
            bomItem.filteredPartTypeIds.length !== bomItem.partTypeIds.length
          ) {
            thunkAPI.dispatch(
              UIActions.OpenModal('ConfirmationDialog', {
                title: i18n.t('project:delete-parts-count', {
                  count: bomItem.filteredPartTypeIds.length,
                }),
                onConfirm: () => {
                  try {
                    return projectAPI.api.DeleteRowOrAssembly(
                      projectAPI.projectId,
                      bomItem.filteredPartTypeIds
                    )
                  } catch (err) {
                    ShowException('project', err)
                    thunkAPI.dispatch(fetchProject(projectAPI.projectId))
                    throw err
                  }
                },
              })
            )
          } else {
            thunkAPI.dispatch(
              UIActions.OpenModal('ConfirmationDialog', {
                title: i18n.t('project:delete-parts-count', {
                  count: bomItem.partTypeIds.length,
                }),
                onConfirm: () => {
                  try {
                    thunkAPI.dispatch(UIActions.CloseModal())
                    thunkAPI.dispatch(
                      newProjectActions.deleteBomItem(bomItemId)
                    )
                    return projectAPI.api.DeleteRowOrAssembly(
                      projectAPI.projectId,
                      [bomItemId]
                    )
                  } catch (err) {
                    ShowException('project', err)
                    thunkAPI.dispatch(fetchProject(projectAPI.projectId))
                    throw err
                  }
                },
                onCancel: () => {
                  return Promise.resolve()
                },
              } as ConfirmationDialogProps)
            )
          }
          break
        default: {
          thunkAPI.dispatch(
            UIActions.OpenModal('ConfirmationDialog', {
              title: i18n.t('project:delete-part-desc', {
                name: bomItem.name,
              }),
              onConfirm: () => {
                try {
                  thunkAPI.dispatch(UIActions.CloseModal())
                  thunkAPI.dispatch(newProjectActions.deleteBomItem(bomItemId))
                  return projectAPI.api.DeleteRowOrAssembly(
                    projectAPI.projectId,
                    [bomItemId]
                  )
                } catch (err) {
                  ShowException('project', err)
                  thunkAPI.dispatch(fetchProject(projectAPI.projectId))
                  throw err
                }
              },
              onCancel: () => {
                return Promise.resolve()
              },
            })
          )
        }
      }
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject(projectAPI.projectId))
      throw err
    }
  }
)
